// @ts-nocheck

/**
 * Custom element <klaviyo-subscribe> que encapsula la llamada a la API v3 de Klaviyo.
 * No se renderiza en el DOM — actúa como servicio compartido.
 *
 * Uso desde otros componentes:
 *   const KlaviyoSubscribe = customElements.get('klaviyo-subscribe');
 *   await KlaviyoSubscribe.subscribe({ companyId, listId, email, source });
 */
class KlaviyoSubscribe extends HTMLElement {
  /**
   * @param {object} options
   * @param {string} options.companyId
   * @param {string} options.listId
   * @param {string} options.email
   * @param {string} [options.revision]
   * @param {string} [options.source]
   */
  static async subscribe({ companyId, listId, email, revision = '2024-10-15', source = 'Website' }) {
    if (!companyId) throw new Error('Missing Klaviyo Company ID');
    if (!listId) throw new Error('Missing Klaviyo List ID');

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: { email },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: listId } },
        },
      },
    };

    const response = await fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          revision,
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const json = await response.json().catch(() => ({}));
      throw new Error(json?.errors?.[0]?.detail || 'Klaviyo error');
    }
  }
}

if (!customElements.get('klaviyo-subscribe')) {
  customElements.define('klaviyo-subscribe', KlaviyoSubscribe);
}
